import React, { useState } from "react";
import {
  CheckBoxInput,
  TextInput,
  TimeInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { facilityAction } from "../../_store";
import { CommissaryFillAll } from "../../validation/facilitySchema";
import FillAll from "../../assets/svg/fill-all.svg";
import { facilitySchema } from "../../validation/facilitySchema";

function AllowableURL({ errorMessage, setError }) {
  const dispatch = useDispatch();
  const facilityInformationData = useSelector((x) => x?.facility?.facilityData);

  const handleChange = (e, row, i) => {
    const { name, value } = e?.target;
    const match = name.match(/Type_CommissaryAccessInterval\.(\d+)\.(\w+)/);

    const facilityData = { ...facilityInformationData };
    const accessData = [
      ...facilityInformationData?.Type_CommissaryAccessInterval,
    ];
    const updatedAccessData = accessData.map((data) => {
      if (data.WeekDayNumber === row?.WeekDayNumber) {
        return {
          ...data,
          [match[2]]: value,
          FacilityID: facilityData?.FacilityID,
        };
      }
      return data; // Keep the other entries unchanged
    });
    facilityData["Type_CommissaryAccessInterval"] = updatedAccessData;
    dispatch(facilityAction?.setFacilityData(facilityData));
  };

  const handleFillAll = () => {
    const facilityData = { ...facilityInformationData };
    const commissiaryData = facilityData["Type_CommissaryAccessInterval"];

    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const validationInput = [
      {
        [`Type_CommissaryAccessInterval.${2}.AccessFromTime`]:
          commissiaryData[0].AccessFromTime,
        [`Type_CommissaryAccessInterval.${2}.AccessToTime`]:
          commissiaryData[0].AccessToTime,
        [`isEnable`]: commissiaryData[0].isEnable,
        [`WeekDayNumber`]: commissiaryData[0].WeekDayNumber,
      },
    ];
    const { error } = CommissaryFillAll({ CommissaryFillAll: validationInput });
    setError((prev) => {
      const updatedErrorMessage = { ...prev };
      for (let i = 1; i <= 7; i++) {
        updatedErrorMessage[
          `Type_CommissaryAccessInterval.${i}.AccessFromTime`
        ] = "";
        updatedErrorMessage[`Type_CommissaryAccessInterval.${i}.AccessToTime`] =
          "";
      }
      return updatedErrorMessage;
    });
    if (error?.details) {
      error.details.forEach((error) => {
        const field =
          error?.path?.length === 1 ? error?.path[0] : error?.path[2]; // Get the actual field name from the error path
        setError((prev) => ({
          ...prev,
          [field]: error.message,
        }));

        const elements = document.getElementsByClassName(field);
        if (elements?.length !== 0) {
          Array.from(elements).forEach((element) => {
            element.classList.add("input-error");
          });
        }
      });
    } else {
      setError((prev) => {
        const updatedErrorMessage = { ...prev };
        for (let i = 1; i <= 7; i++) {
          updatedErrorMessage[
            `Type_CommissaryAccessInterval.${i}.AccessFromTime`
          ] = "";
          updatedErrorMessage[
            `Type_CommissaryAccessInterval.${i}.AccessToTime`
          ] = "";
        }
        return updatedErrorMessage;
      });
      const fromTime = commissiaryData[0]?.AccessFromTime;
      const toTime = commissiaryData[0]?.AccessToTime;

      const updatedCommissary = commissiaryData?.map((data, i) => ({
        ...data,
        isEnable: true,
        AccessFromTime: fromTime,
        AccessToTime: toTime,
        FacilityID: facilityData?.FacilityID,
      }));
      facilityData["Type_CommissaryAccessInterval"] = updatedCommissary;
      dispatch(facilityAction?.setFacilityData(facilityData));
    }
  };

  const handleDay = (e, row, i) => {
    const { checked } = e?.target;
    const facilityData = {
      ...facilityInformationData,
    };
    const accessData = [...facilityData["Type_CommissaryAccessInterval"]];
    setError((prev) => {
      const updatedErrorMessage = { ...prev };
      updatedErrorMessage[
        `Type_CommissaryAccessInterval.${row?.WeekDayNumber}.AccessFromTime`
      ] = "";
      updatedErrorMessage[
        `Type_CommissaryAccessInterval.${row?.WeekDayNumber}.AccessToTime`
      ] = "";
      return updatedErrorMessage;
    });
    const updatedAccessData = accessData.map((data) => {
      if (data.WeekDayNumber === row?.WeekDayNumber) {
        return {
          ...data,
          isEnable: checked,
          AccessFromTime: checked ? row?.AccessFromTime : "",
          AccessToTime: checked ? row?.AccessToTime : "",
          FacilityID: facilityData?.FacilityID,
        };
      }
      return data; // Keep the other entries unchanged
    });
    facilityData["Type_CommissaryAccessInterval"] = updatedAccessData;
    dispatch(facilityAction?.setFacilityData(facilityData));
  };

  const lawLibraryLikChange = (e) => {
    const facilityData = { ...facilityInformationData };
    const { name, value } = e?.target;
    facilityData[name] = value;
    dispatch(facilityAction.setFacilityData(facilityData));
  };

  const handleBlurAllowUrlInfo = async (e) => {
    let { name, value } = e.target;
    try {
      // Clear error if validation passes
      setError((prev) => ({
        ...prev,
        [name]: "", // Clear the specific field error
      }));

      const facilityData = { ...facilityInformationData };
      facilityData[name] = value ? value.trim() : "";
      dispatch(facilityAction.setFacilityData(facilityData));
      // Validate the field using the Joi schema and handle both required and other validation
      let objField = { [name]: value };
      await facilitySchema.validateAsync(
        {
          ...objField,
          IsLawLibraryAccess: facilityInformationData?.IsLawLibraryAccess,
          IsCommissaryAccess: facilityInformationData?.IsCommissaryAccess,
        },
        { abortEarly: false }
      );
    } catch (err) {
      // Find the error that matches the current field name
      const fieldError = err.details.find((error) => error.path.includes(name));

      if (fieldError) {
        setError((prev) => ({
          ...prev,
          [name]: fieldError.message, // Set the specific field error from Joi
        }));
      }
    }
  };

  return (
    <div className="mt-3 mb-3">
      <h4
        className="inner-header-bg text-color"
        style={{ cursor: "pointer" }}
        title="To display the URL's in the respective sections of inmate login"
      >
        <i className="fas fa-link me-2"></i>Allowable URLs
      </h4>
      <div className="row mb-3">
        {/* Law Library Field */}
        <div className="col-md-6">
          <div className="form-floating mb-3">
            <TextInput
              name="LawLibraryLink"
              id="code"
              label="Law Library"
              placeholder="Enter Law Library URL"
              required={
                facilityInformationData?.IsLawLibraryAccess == 1 ? true : false
              }
              value={facilityInformationData?.LawLibraryLink}
              disabled={!facilityInformationData?.IsLawLibraryAccess}
              handleChange={lawLibraryLikChange}
              errorMessage={errorMessage}
              handleBlur={handleBlurAllowUrlInfo}
            />
          </div>
        </div>

        {/* Commissary and Button */}
        <div className="col-md-6">
          <div className="row d-flex flex-wrap justify-content-center align-items-center">
            {/* Commissary URL Input */}

            <TextInput
              name="CommissaryAccessLink"
              id="commissary"
              label="Commissary"
              placeholder="Enter Commissary URL"
              required={
                facilityInformationData?.IsCommissaryAccess == 1 ? true : false
              }
              // value={
              //   facilityInformationData?.IsCommissaryAccess
              //     ? facilityInformationData?.CommissaryAccessLink
              //     : ""
              // }
              value={facilityInformationData?.CommissaryAccessLink}
              disabled={!facilityInformationData?.IsCommissaryAccess}
              handleChange={lawLibraryLikChange}
              errorMessage={errorMessage}
              handleBlur={handleBlurAllowUrlInfo}
              maxLength={200}
            />
          </div>

          {/* Days of the Week Checkboxes and Time Inputs */}
          <div className="row">
            <div className="col-12">
              {facilityInformationData["Type_CommissaryAccessInterval"]?.map(
                (item, i) => {
                  const day = [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                    "Sunday",
                  ];
                  return (
                    <div className="form-group mb-2" key={i}>
                      <div className="d-flex flex-wrap justify-content-start align-items-center gap-2 mb-1">
                        <CheckBoxInput
                          label={day[i]}
                          id={day[i]}
                          disabled={
                            !facilityInformationData?.IsCommissaryAccess
                          }
                          checked={
                            (facilityInformationData?.IsCommissaryAccess &&
                              facilityInformationData[
                              "Type_CommissaryAccessInterval"
                              ][i]["AccessFromTime"] !== "" &&
                              facilityInformationData[
                              "Type_CommissaryAccessInterval"
                              ][i]["AccessToTime"] !== "") ||
                            (facilityInformationData?.IsCommissaryAccess &&
                              facilityInformationData?.[
                              "Type_CommissaryAccessInterval"
                              ][i]?.["isEnable"]) ||
                            false
                          }
                          handleClick={(e) => handleDay(e, item, i)}
                        />

                        {i === 0 &&
                          facilityInformationData?.IsCommissaryAccess === 1 &&
                          facilityInformationData[
                          "Type_CommissaryAccessInterval"
                          ][i]["isEnable"] && (
                            <Button
                              label="Fill all"
                              status="btn-label"
                              imgsrc={FillAll}
                              className="mt-2 mb-2"
                              type="button"
                              disabled={
                                !facilityInformationData?.IsCommissaryAccess
                              }
                              onClick={() => handleFillAll()}
                            />
                          )}
                      </div>

                      <div className="row">
                        <div className="col-6">
                          {/*<TimeInput /> */}

                          <TimeInput
                            name={`Type_CommissaryAccessInterval.${item?.WeekDayNumber}.AccessFromTime`}
                            cName={`date-icon-1 AccessFromTime-${i}`}
                            handleChange={(e) => handleChange(e, item, i)}
                            disabled={
                              !facilityInformationData?.IsCommissaryAccess ||
                              !facilityInformationData[
                              "Type_CommissaryAccessInterval"
                              ][i]["isEnable"]
                            }
                            placeholder={"02:00"}
                            value={
                              facilityInformationData?.IsCommissaryAccess
                                ? facilityInformationData[
                                "Type_CommissaryAccessInterval"
                                ][i]["AccessFromTime"]
                                : ""
                            }
                          />
                          {Object?.keys(errorMessage).length > 0 && (
                            <div className="text-danger fw-700 fs-6">
                              {errorMessage[
                                `Type_CommissaryAccessInterval.${item?.WeekDayNumber}.AccessFromTime`
                              ] &&
                                errorMessage[
                                `Type_CommissaryAccessInterval.${item?.WeekDayNumber}.AccessFromTime`
                                ]}
                            </div>
                          )}
                        </div>
                        <div className="col-6">
                          <TimeInput
                            name={` Type_CommissaryAccessInterval.${item?.WeekDayNumber}.AccessToTime`}
                            cName={`date-icon-1 AccessToTime-${i}`}
                            handleChange={(e) => handleChange(e, item, i)}
                            disabled={
                              !facilityInformationData?.IsCommissaryAccess ||
                              !facilityInformationData[
                              "Type_CommissaryAccessInterval"
                              ][i]["isEnable"]
                            }
                            placeholder={"03:24"}
                            value={
                              facilityInformationData?.IsCommissaryAccess
                                ? facilityInformationData[
                                "Type_CommissaryAccessInterval"
                                ][i]["AccessToTime"]
                                : ""
                            }
                          />
                          {Object?.keys(errorMessage).length > 0 && (
                            <div className="text-danger fw-700 fs-6">
                              {errorMessage[
                                `Type_CommissaryAccessInterval.${item?.WeekDayNumber}.AccessToTime`
                              ] &&
                                errorMessage[
                                `Type_CommissaryAccessInterval.${item?.WeekDayNumber}.AccessToTime`
                                ]}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(AllowableURL);
